import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deleteSpaceVolumeSchema = z.object({
  spaceId: z.string(),
  branchId: z.string(),
  volumeId: z.string(),
});

export const deleteSpaceVolume = mutator({
  schema: deleteSpaceVolumeSchema,
  resolve: {
    space: { kind: "space", from: "spaceId" },
  },
  permissions: [
    {
      permission: "space:write",
      scopeId: ({ args }) => args.space.id,
    },
  ],
  fn: async ({ tx, args: { space, branchId, volumeId } }) => {
    const [volume] = await tx.run(
      zql.spaceVolumes
        .where("id", volumeId)
        .where("spaceId", space.id)
        .where("branchId", branchId)
    );
    if (!volume) throw userFacingError("Volume not found");

    await tx.mutate.spaceVolumes.delete({ id: volumeId });
  },
});
